import { Keyboard, Linking } from 'react-native';
import { store } from '../store/store';

import { getBaseHref } from '../utils/services/CommonUtils';
import { backpressBheaviour$ } from '../utils/services/subject-behaviour/CommonRxjsService';

import { AppGUID, OMSWAChatbotNumber, UserDummyId, WABaseURL } from '../utils/constants/AppConstants';
import { ancestorRouteMapping, eventDispatchingMapping, ScreenRoute } from '../utils/constants/ScreenRouteConstant';

import moment from 'moment-mini';

export const getBackPressAncestorRouteMapping = (lastPath) => {
  if (lastPath && ancestorRouteMapping.hasOwnProperty(lastPath.substring(2))) {
    return { hasProperty: true, route: ancestorRouteMapping[lastPath.substring(2)] }
  } else return { hasProperty: false, route: null }
}

export const getBackPressEventDispatchMapping = (lastPath) => {
  if (lastPath && eventDispatchingMapping.hasOwnProperty(lastPath.substring(2))) {
    return { hasProperty: true, configState: eventDispatchingMapping[lastPath.substring(2)] }
  } else return { hasProperty: false, configState: null }
}

export const handleAndroidBackPressNavigation = (props) => {
  // const lastHashCode = global.lastHashCode
  // const ancestorRouteMapping = getBackPressAncestorRouteMapping(lastHashCode)
  // if (ancestorRouteMapping.hasProperty) {
  //     if (ancestorRouteMapping.route) {
  //         if (ancestorRouteMapping.route == lastHashCode.substring(2)) {
  //             document.title = 'Aayu App';
  //             global.lastHashCode = ancestorRouteMapping.route;
  //             window.history.pushState(null, 'Aayu App', window.location.origin + getBaseHref() + '/' + ancestorRouteMapping.route);
  //         } else {
  //             global.lastHashCode = '#/' + ancestorRouteMapping.route;
  //             props?.navigation?.navigate(ancestorRouteMapping.route);
  //         }
  //     } else {
  //         window.history.pushState(null, '', window.location.origin + getBaseHref() + '/' + location.hash);
  //         global.lastHashCode = location.hash;
  //         props?.navigation?.pop();
  //     }
  // } else {
  //     window.history.pushState(null, '', window.location.origin + getBaseHref() + '/' + location.hash);
  //     global.lastHashCode = location.hash;
  //     props?.navigation?.pop();
  // }
  const __lastPath = global.lastHashCode;
  const __ancestorRouteMapping = getBackPressAncestorRouteMapping(__lastPath)

  console.log('####', props)
  console.log('####', 'ancestor mapping', __ancestorRouteMapping)

  if (__lastPath == "/selected_pharmacy") {
    if (location.pathname == '/' + ScreenRoute.oms_detect_user_location) {
      window.history.pushState(null, '', window.location.origin + getBaseHref() + '/' + location.pathname);
      global.lastHashCode = location.pathname;
      props?.navigation?.navigate(ScreenRoute.oms_detect_user_location);
    } else if (location.pathname == '/pharmacy_list') {
      window.history.pushState(null, '', window.location.origin + getBaseHref() + '/' + location.pathname);
      global.lastHashCode = location.pathname;
      props?.navigation?.pop();
    } else {
      global.lastHashCode = '/' + __ancestorRouteMapping.route;
      props?.navigation?.navigate(__ancestorRouteMapping.route);
    }
  } else if (__ancestorRouteMapping.hasProperty) {
    if (__ancestorRouteMapping.route) {
      const eventDispatchingMapping = getBackPressEventDispatchMapping(__lastPath)
      if (eventDispatchingMapping.hasProperty) {
        setTimeout(() => {
          if (eventDispatchingMapping.configState) {
            backpressBheaviour$.next({
              backpress: true,
              backpressData: eventDispatchingMapping.configState
            })
          }
        }, 200);
      } else {
        global.lastHashCode = '/' + __ancestorRouteMapping.route;
        props?.navigation?.navigate(__ancestorRouteMapping.route);
        // window.history.pushState(null, '', window.location.origin + getBaseHref() + '/' + __lastPath);
      }
    } else {
      document.title = 'Aayu App';
      global.lastHashCode = __lastPath;
      window.history.pushState(null, 'Aayu App', window.location.origin + getBaseHref() + '/' + __lastPath);
    }
  } else {
    const eventDispatchingMapping = getBackPressEventDispatchMapping(__lastPath)
    if (eventDispatchingMapping.hasProperty) {
      setTimeout(() => {
        if (eventDispatchingMapping.configState) {
          backpressBheaviour$.next({
            backpress: true,
            backpressData: eventDispatchingMapping.configState
          })
        }
      }, 200);
    } else {
      window.history.pushState(null, '', window.location.origin + getBaseHref() + '/' + location.pathname);
      global.lastHashCode = location.pathname;
      props?.navigation?.pop();
    }
  }
  // document.title = 'Aayu App';
  // global.lastHashCode = ancestorRouteMapping.route;
  // window.history.pushState(null, 'Aayu App', window.location.origin + getBaseHref() + '/' + ancestorRouteMapping.route);
}

const handleAppBackPressNavigation = (props) => {
  console.log("####, in common services\ntime: " +
    moment().utcOffset('+05:30').format('DD, hh:mm:ss a') +
    '\nlast: ' + global.lastHashCode,
    '\nnew: ' + location.pathname +
    "\nhas active pop up: " + global.hasActivePopup +
    "\nnavigateFrom: " + global.navigateFrom +
    "\nappHandledBackpress: " + global.appHandledBackpress +
    '\npop state: ' + window.onpopstate)

  const __lastHashCode = global.lastHashCode
  const __ancestorRouteMapping = getBackPressAncestorRouteMapping(__lastHashCode)
  if (__ancestorRouteMapping.hasProperty) {
    if (__ancestorRouteMapping.route) {
      if (__ancestorRouteMapping.route == __lastHashCode.substring(2)) {
      } else {
        if (__lastHashCode == '/' + ScreenRoute.oms_detect_user_location ||
          __lastHashCode == '/' + ScreenRoute.list_pharmacy) {
          props?.navigation?.pop()
        } else props?.navigation.replace(__ancestorRouteMapping.route)
      }
    } else {
      props?.navigation.goBack();
    }
  } else {
    if (global.hasActivePopup) {
      backpressBheaviour$.next({
        backpress: true,
        backpressData: { hasActivePopup: false }
      })
    } else {
      props?.navigation.goBack()
      global.navigateFrom = ''
      global.appHandledBackpress = true
    }
  }
  // else {
  //   props?.navigation.goBack();
  // }
  // global.navigateFrom = ''
  // global.appHandledBackpress = true

  // if (props.onBackPressRoute)
  //         props?.navigation?.navigate(props.onBackPressRoute);
  //     else
  //         props?.navigation.goBack();
}
const handleBackPressNavigation = (props) => {
  handleAppBackPressNavigation(props)
}

function isConsultationService(serviceName) {
  if (serviceName == 'Remote Consultation') {
    return true;
  } else { return false; }
}

export const handleBackPress = (props) => {
  Keyboard.dismiss()
  if (eventDispatchingMapping.hasProperty) {
    setTimeout(() => {
      if (eventDispatchingMapping.configState) {
        backpressBheaviour$.next({
          backpress: true,
          backpressData: eventDispatchingMapping.configState
        })
      }
    }, 200);
  } else {
    handleAppBackPressNavigation(props)
  }
}

export const handleModalBackpress = (modalData, { showModal, setModal, modalDataSubscriber }) => {
  if (modalData.active) {
    if (showModal != modalData.active) {
      setModal(modalData?.active)
      modalDataSubscriber(modalData)
    }
  } else {
    setModal(false)
    modalDataSubscriber(modalData)
  }
}

export const pwaGUID = () => {
  const reduxState = store.getState()
  let familyId = reduxState.userDetails['familyId'] ?? UserDummyId
  return AppGUID + familyId
}

export const openWAURL = (additionalChatbotCommand = 'Hi') => {
  Linking.openURL(WABaseURL + additionalChatbotCommand);
}

export const openTeleponeWindow = () => {
  Linking.openURL(`tel:${OMSWAChatbotNumber}`);
}